import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import ArrowDown from './../arrowDown';

import './styles.css';

const Popover = (props) => {
  const {
    arrowStyle,
    title,
    content,
    isActive,
    className
  } = props;

  let bodyText =  '';

  if( typeof content === 'string' ) {
    bodyText = <Text>{content}</Text>;
  } else {
    bodyText = content;
  }

  return (
    <View
      style={{ display: isActive ? 'flex' : 'none' }}
      className={`popover ${className}`}
    >
      <View className={'popover__body'}>
        {
          title &&
          <View className={'popover__title-container'}>
            <Text className={'popover__title'}>
              {title}
            </Text>
          </View>
        }
        {
          content &&
          <View className={'popover__content'}>
            {
              bodyText
            }
          </View>
        }
        <ArrowDown
          style={arrowStyle}
          className={'popover__arrow'}
        />
      </View>
    </View>
  );
};

Popover.propTypes = {
  // todo replace with dbk popover
  // style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  // arrowStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isActive: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  // content: PropTypes.string,
};

Popover.defaultProps = {
  style: {},
  arrowStyle: {},
  className: '',
  isActive: false,
  title: undefined,
  content: undefined,
};

export default Popover;
